// 系统内置页面，正式使用时也不应该被删除
export default [
	{
		path: '/index',
		name: 'Home',
		component: () => import(/* webpackChunkName: "home" */ '@/views/dashboard/Home.vue'),
		meta: {} // 必须有这个空对象
	},
	{
		path: '/welcome',
		name: 'Welcome',
		component: () => import(/* webpackChunkName: "welcome" */ '@/views/dashboard/Welcome.vue'),
		meta: {} // 必须有这个空对象
	},

	{
		path: '/401',
		name: 'Err401', // 如果不需要tab则可以删除此属性
		component: () => import(/* webpackChunkName: "401" */ '@/views/errorpage/404.vue'),
		meta: { title: '401' }
	},
	{
		path: '/404',
		name: 'Err404',
		component: () => import(/* webpackChunkName: "404" */ '@/views/errorpage/404.vue'),
		meta: { title: '404' }
	},
	{
		path: '/redirect/:path*',
		name: 'redirect',
		component: () => import(/* webpackChunkName: "redirect" */ '@/views/Redirect.vue'),
		meta: {}
	}
];
